      <div class="row" style="row-gap: 15px;margin-top: 30px;">
        <div *ngFor="let item of services" class="col-md-3 col-12 discount-col">
          <app-mini-env-info-card [icon1]="sharedService.imagesUrl + item.icon" 
                                  [icon2]="sharedService.imagesUrl + 'free-icon.png'"
                                  [icon3]="sharedService.imagesUrl + 'arrow-circle-right.png'"
                                  [title]="item.title"
                                  [description]="item.description"
                                  [isFree]="item.isFree"
                                  [link]="item.link">
          </app-mini-env-info-card>
        </div>
      </div>